/**
 * bundle-configurator.js
 * Reads product.metafields.custom.bundle_config (type: JSON) from a
 * data-config attribute on #bundle-configurator and renders the
 * appropriate bundle UI, then hooks into the product form submit.
 *
 * Supported config types:
 *   fixed   — per-item option selectors (colour, size etc.)
 *   mix     — N slots, each with options + qty, total must equal config.total
 *   sections — multiple fixed/mix sections (e.g. workwear bundle)
 */
(function () {
  'use strict';

  var container = document.getElementById('bundle-configurator');
  if (!container) return;

  var config;
  try {
    config = JSON.parse(container.getAttribute('data-config'));
  } catch (e) {
    console.error('[bundle-configurator] Config parse error:', e);
    return;
  }

  /* ─── Styles ─────────────────────────────────────────────────── */
  var css = document.createElement('style');
  css.textContent = [
    '.bc-wrap{border:1.5px solid #e2e8f0;border-radius:10px;padding:24px;margin:20px 0}',
    '.bc-heading{font-size:15px;font-weight:700;color:#0d1b2a;margin:0 0 4px}',
    '.bc-sub{font-size:13px;color:#64748b;margin:0 0 20px}',

    /* Fixed — item cards */
    '.bc-item{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:16px;margin-bottom:12px}',
    '.bc-item__label{font-size:12px;font-weight:700;color:#0d1b2a;margin:0 0 12px;text-transform:uppercase;letter-spacing:.05em}',

    /* Option groups */
    '.bc-opt-group{margin-bottom:10px}',
    '.bc-opt-name{display:block;font-size:11px;font-weight:600;color:#64748b;margin-bottom:6px;text-transform:uppercase;letter-spacing:.04em}',
    '.bc-opt-vals{display:flex;flex-wrap:wrap;gap:6px}',
    '.bc-opt-lbl{position:relative;cursor:pointer}',
    '.bc-opt-lbl input{position:absolute;opacity:0;width:0;height:0}',
    '.bc-opt-lbl span{display:inline-block;padding:6px 12px;border:1.5px solid #dde3ea;border-radius:6px;font-size:13px;font-weight:500;cursor:pointer;transition:all .15s;background:#fff;color:#333}',
    '.bc-opt-lbl input:checked+span{border-color:#1a73e8;background:#e8f0fe;color:#1a73e8;font-weight:600}',
    '.bc-opt-lbl span:hover{border-color:#1a73e8}',

    /* Mix — slot rows */
    '.bc-slot{display:grid;grid-template-columns:1fr auto;gap:16px;align-items:end;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:16px;margin-bottom:10px}',
    '.bc-slot__opts{display:flex;flex-wrap:wrap;gap:12px}',
    '.bc-slot__qty-wrap{display:flex;flex-direction:column;gap:4px;min-width:72px}',
    '.bc-slot__qty-lbl{font-size:11px;font-weight:600;color:#64748b;text-transform:uppercase;letter-spacing:.04em}',
    '.bc-slot__qty{width:68px;padding:8px 6px;border:1.5px solid #dde3ea;border-radius:6px;text-align:center;font-size:15px;font-weight:600;font-family:inherit}',
    '.bc-slot__qty:focus{outline:none;border-color:#1a73e8}',

    /* Running total pill */
    '.bc-total{display:flex;align-items:center;gap:10px;padding:10px 14px;background:#f1f5f9;border-radius:8px;font-size:13px;font-weight:600;color:#0d1b2a;margin-top:4px;margin-bottom:4px}',
    '.bc-total__n{font-size:20px;font-weight:800;color:#94a3b8;transition:color .2s}',
    '.bc-total__n.bc-exact{color:#16a34a}',
    '.bc-total__n.bc-over{color:#ef4444}',

    /* Sections */
    '.bc-section{margin-bottom:24px}',
    '.bc-section__hd{font-size:13px;font-weight:700;color:#1a73e8;margin:0 0 12px;padding-bottom:8px;border-bottom:2px solid #e2e8f0;text-transform:uppercase;letter-spacing:.05em}',
    '.bc-bundle-opts{background:#eef4ff;border:1.5px solid #bfdbfe;border-radius:8px;padding:16px;margin-bottom:16px}',
    '.bc-bundle-opts__label{font-size:12px;font-weight:700;color:#1a2b5e;margin:0 0 10px;text-transform:uppercase;letter-spacing:.05em}',
    '.bc-opt-multi-hint{font-style:normal;font-weight:400;font-size:0.82em;text-transform:none;letter-spacing:0;color:#555;margin-left:4px}',
    '.bc-item--optional{border-style:dashed}',
    '.bc-item__opt-badge{font-size:11px;font-weight:400;color:#94a3b8;text-transform:none;letter-spacing:0;margin-left:6px}',
    '.bc-req-one{font-size:12px;color:#64748b;margin:8px 0 0;font-style:italic}',
    '.bc-error-banner{display:none;background:#fef2f2;border:1.5px solid #fca5a5;border-radius:8px;padding:12px 16px;margin-top:16px;font-size:14px;font-weight:600;color:#dc2626;line-height:1.5}',
    '.bc-error-banner.visible{display:block}',

    /* Logo upload */
    '.bc-logo{position:relative;border:1.5px dashed #cbd5e1;border-radius:8px;padding:16px;margin-top:16px;text-align:center;cursor:pointer;transition:border-color .15s}',
    '.bc-logo:hover{border-color:#1a73e8}',
    '.bc-logo input[type=file]{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%}',
    '.bc-logo__lbl{font-size:13px;font-weight:600;color:#475569;margin:0 0 2px}',
    '.bc-logo__hint{font-size:12px;color:#94a3b8;margin:0}',
    '.bc-logo__prev{max-width:120px;max-height:60px;margin:8px auto 0;display:none;border-radius:4px}',
    '.bc-logo--busy{opacity:.55;pointer-events:none}',
    '.bc-logo--done{border-style:solid;border-color:#16a34a}',
    '.bc-slot--hidden{display:none}',
    '@keyframes bc-slot-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}',
    '.bc-slot--appearing{animation:bc-slot-in .25s ease}',

    /* Responsive */
    '@media(max-width:600px){.bc-slot{grid-template-columns:1fr}.bc-slot__qty-wrap{flex-direction:row;align-items:center;gap:8px}}'
  ].join('');
  document.head.appendChild(css);

  /* ─── Helpers ─────────────────────────────────────────────────── */
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** Render a group of option selectors. If opt.multi is true, renders checkboxes (multi-select)
   *  instead of radio buttons (single-select). */
  function renderOpts(opts, prefix) {
    return opts.map(function (opt, oi) {
      var isMulti = opt.multi === true;
      return '<div class="bc-opt-group">'
        + '<span class="bc-opt-name">' + esc(opt.name)
        + (isMulti ? ' <em class="bc-opt-multi-hint">(select all that apply)</em>' : '')
        + '</span>'
        + '<div class="bc-opt-vals">'
        + opt.values.map(function (val, vi) {
          // val may be a plain string or {label, variant_id}
          var label = (typeof val === 'object' && val !== null) ? val.label : val;
          var id = prefix + 'o' + oi + 'v' + vi;
          // Checkboxes each need a unique name; radios share the same group name
          var inputType = isMulti ? 'checkbox' : 'radio';
          var inputName = isMulti ? id : esc(prefix + 'o' + oi);
          return '<label class="bc-opt-lbl" for="' + id + '">'
            + '<input type="' + inputType + '" id="' + id + '" name="' + inputName + '" value="' + esc(label) + '">'
            + '<span>' + esc(label) + '</span>'
            + '</label>';
        }).join('')
        + '</div></div>';
    }).join('');
  }

  /** Render a mix-type slot row */
  function renderSlot(opts, prefix, slotIdx, maxQty) {
    return '<div class="bc-slot" data-slot-prefix="' + esc(prefix) + '" data-slot-idx="' + slotIdx + '">'
      + '<div class="bc-slot__opts">' + renderOpts(opts, prefix + 's' + slotIdx) + '</div>'
      + '<div class="bc-slot__qty-wrap">'
      + '<span class="bc-slot__qty-lbl">Qty</span>'
      + '<input type="number" class="bc-slot__qty" data-slot-ref="' + esc(prefix) + '" value="0" min="0" max="' + maxQty + '">'
      + '</div></div>';
  }

  /* ─── Build HTML ──────────────────────────────────────────────── */
  var html = '';

  if (config.type === 'fixed') {
    html += '<div class="bc-wrap">'
      + '<p class="bc-heading">Configure your bundle</p>'
      + '<p class="bc-sub">Select options for each item in the bundle.</p>';
    // Bundle-level options (e.g. print position) — appear once above the items
    if (config.bundle_options && config.bundle_options.length) {
      html += '<div class="bc-bundle-opts">'
        + '<p class="bc-bundle-opts__label">Bundle options</p>'
        + renderOpts(config.bundle_options, 'bcg')
        + '</div>';
    }
    (config.items || []).forEach(function (item, i) {
      html += '<div class="bc-item" data-bc-item="' + i + '">'
        + '<p class="bc-item__label">' + esc(item.label) + '</p>'
        + renderOpts(item.options || [], 'bcii' + i)
        + '</div>';
    });
    if (config.logo_upload) html += renderLogoHtml();
    html += '</div>';

  } else if (config.type === 'mix') {
    var tot = config.total || 0;
    var slots = config.slots || 3;
    html += '<div class="bc-wrap">'
      + '<p class="bc-heading">Build your bundle</p>'
      + '<p class="bc-sub">Choose ' + tot + ' item' + (tot !== 1 ? 's' : '') + ' total across up to ' + slots + ' row' + (slots !== 1 ? 's' : '') + '. Set a row\'s qty to 0 to leave it empty.</p>';
    for (var s = 0; s < slots; s++) {
      html += renderSlot(config.options || [], 'bcm', s, tot);
    }
    html += '<div class="bc-total"><span>Total:</span>'
      + '<span class="bc-total__n" id="bc-tot-main">0</span>'
      + '<span>/ ' + tot + '</span></div>';
    if (config.logo_upload) html += renderLogoHtml();
    html += '</div>';

  } else if (config.type === 'sections') {
    html += '<div class="bc-wrap"><p class="bc-heading">Configure your bundle</p>';
    (config.sections || []).forEach(function (sec, si) {
      html += '<div class="bc-section">'
        + '<p class="bc-section__hd">' + esc(sec.label) + '</p>';
      if (sec.type === 'fixed') {
        (sec.items || []).forEach(function (item, i) {
          html += '<div class="bc-item' + (item.optional ? ' bc-item--optional' : '') + '" data-bc-sec="' + si + '" data-bc-item="' + i + '">'
            + '<p class="bc-item__label">' + esc(item.label)
            + (item.optional ? '<span class="bc-item__opt-badge">— or leave blank</span>' : '')
            + '</p>'
            + renderOpts(item.options || [], 'bcs' + si + 'i' + i)
            + '</div>';
        });
        if (sec.require_one) {
          html += '<p class="bc-req-one">Select and complete one of the options above.</p>';
        }
      } else if (sec.type === 'mix') {
        var secSlots = sec.slots || 3;
        var secTot = sec.total || 0;
        html += '<p class="bc-sub" style="margin-top:-8px">Choose ' + secTot + ' item' + (secTot !== 1 ? 's' : '') + ' for this section.</p>';
        for (var ms = 0; ms < secSlots; ms++) {
          html += renderSlot(sec.options || [], 'bcs' + si + 'm', ms, secTot);
        }
        html += '<div class="bc-total"><span>' + esc(sec.label) + ' total:</span>'
          + '<span class="bc-total__n" id="bc-tot-sec-' + si + '">0</span>'
          + '<span>/ ' + secTot + '</span></div>';
      }
      html += '</div>';
    });
    if (config.logo_upload) html += renderLogoHtml();
    html += '</div>';
  }

  function renderLogoHtml() {
    return '<div class="bc-logo" id="bc-logo-area">'
      + '<input type="file" id="bc-logo-file" accept="image/png,image/jpeg,image/svg+xml,image/gif">'
      + '<p class="bc-logo__lbl">Upload your logo <span style="font-weight:400;color:#94a3b8">(optional)</span></p>'
      + '<p class="bc-logo__hint">PNG, JPG or SVG — max 5 MB</p>'
      + '<img class="bc-logo__prev" id="bc-logo-prev" alt="Logo preview">'
      + '</div>';
  }

  container.innerHTML = html;

  /* ─── Wire running totals + dynamic row reveal ───────────────── */
  function wireTotals(prefix, targetTotal, counterId, numSlots) {
    var counter = document.getElementById(counterId);

    function getSlot(i) {
      return container.querySelector('.bc-slot[data-slot-prefix="' + prefix + '"][data-slot-idx="' + i + '"]');
    }
    function getQty(slotEl) {
      var el = slotEl ? slotEl.querySelector('.bc-slot__qty') : null;
      return el ? Math.max(0, parseInt(el.value || '0', 10)) : 0;
    }

    function refreshAll() {
      var cumulative = 0;
      for (var i = 0; i < numSlots; i++) {
        var slotEl = getSlot(i);
        if (!slotEl) continue;

        var shouldShow;
        if (i === 0) {
          shouldShow = true;
        } else {
          var prev = getSlot(i - 1);
          shouldShow = prev
            && !prev.classList.contains('bc-slot--hidden')
            && getQty(prev) > 0
            && cumulative < targetTotal;
        }

        if (shouldShow) {
          if (slotEl.classList.contains('bc-slot--hidden')) {
            slotEl.classList.remove('bc-slot--hidden');
            slotEl.classList.add('bc-slot--appearing');
            slotEl.addEventListener('animationend', function () {
              this.classList.remove('bc-slot--appearing');
            }, { once: true });
          }
          cumulative += getQty(slotEl);
        } else {
          // Clear and hide
          var qtyEl = slotEl.querySelector('.bc-slot__qty');
          if (qtyEl) qtyEl.value = '0';
          slotEl.querySelectorAll('input[type=radio]:checked').forEach(function (r) { r.checked = false; });
          slotEl.classList.remove('bc-slot--appearing');
          slotEl.classList.add('bc-slot--hidden');
        }
      }

      // Update counter from visible slots
      if (counter) {
        var total = 0;
        for (var j = 0; j < numSlots; j++) {
          var s = getSlot(j);
          if (s && !s.classList.contains('bc-slot--hidden')) total += getQty(s);
        }
        counter.textContent = total;
        counter.className = 'bc-total__n' + (total === targetTotal ? ' bc-exact' : total > targetTotal ? ' bc-over' : '');
      }
    }

    // Initially hide all rows except the first
    for (var i = 1; i < numSlots; i++) {
      var s = getSlot(i);
      if (s) s.classList.add('bc-slot--hidden');
    }

    // Wire all qty inputs — including hidden ones (they're in the DOM, just not visible)
    container.querySelectorAll('[data-slot-ref="' + prefix + '"]').forEach(function (inp) {
      inp.addEventListener('input', refreshAll);
    });

    refreshAll();
  }

  if (config.type === 'mix') {
    wireTotals('bcm', config.total || 0, 'bc-tot-main', config.slots || 3);
  } else if (config.type === 'sections') {
    (config.sections || []).forEach(function (sec, si) {
      if (sec.type === 'mix') wireTotals('bcs' + si + 'm', sec.total || 0, 'bc-tot-sec-' + si, sec.slots || 3);
    });
  }

  /* ─── Logo upload ─────────────────────────────────────────────── */
  var logoUrl = null;
  var logoFile = document.getElementById('bc-logo-file');
  if (logoFile) {
    logoFile.addEventListener('change', function () {
      var file = logoFile.files[0];
      if (!file) return;
      var area = document.getElementById('bc-logo-area');
      var prev = document.getElementById('bc-logo-prev');
      // Show local preview
      var previewReader = new FileReader();
      previewReader.onload = function (e) {
        if (prev) { prev.src = e.target.result; prev.style.display = 'block'; }
      };
      previewReader.readAsDataURL(file);
      // Upload to proxy
      if (area) area.classList.add('bc-logo--busy');
      var uploadReader = new FileReader();
      uploadReader.onload = function (e) {
        var dataUrl = e.target.result; // full data URL e.g. data:image/png;base64,...
        fetch('/apps/personalizer/logo', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ logo: dataUrl })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Upload HTTP ' + r.status);
            return r.json();
          })
          .then(function (d) {
            logoUrl = d.logoUrl || d.url || null;
            if (area) { area.classList.remove('bc-logo--busy'); area.classList.add('bc-logo--done'); }
          })
          .catch(function (err) {
            if (area) area.classList.remove('bc-logo--busy');
            console.warn('[bundle-configurator] Logo upload failed:', err);
          });
      };
      uploadReader.readAsDataURL(file);
    });
  }

  /* ─── Collect & validate ──────────────────────────────────────── */
  function getChecked(name) {
    var el = container.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  function collectFixed(items, prefix, labelPrefix, requireOne) {
    var props = {};
    var errors = [];
    var optionalCompleted = 0;
    var hasOptional = false;

    (items || []).forEach(function (item, i) {
      if (item.optional) {
        hasOptional = true;
        // Check if ANY option is selected for this item
        var anySelected = (item.options || []).some(function (opt, oi) {
          return getChecked(prefix + 'i' + i + 'o' + oi) !== null;
        });
        if (!anySelected) return; // Completely blank — skip without error

        // Partially or fully filled — require all options
        var allOk = true;
        (item.options || []).forEach(function (opt, oi) {
          var val = getChecked(prefix + 'i' + i + 'o' + oi);
          var key = (labelPrefix ? labelPrefix + ' — ' : '') + item.label + ' — ' + opt.name;
          if (val) {
            props[key] = val;
          } else {
            allOk = false;
            errors.push('Please complete all options for ' + item.label + ', or leave it entirely blank');
          }
        });
        if (allOk) optionalCompleted++;
      } else {
        // Required item — all options must be selected
        (item.options || []).forEach(function (opt, oi) {
          var val = getChecked(prefix + 'i' + i + 'o' + oi);
          var key = (labelPrefix ? labelPrefix + ' — ' : '') + item.label + ' — ' + opt.name;
          if (val) {
            props[key] = val;
          } else {
            errors.push('Please select ' + opt.name + ' for ' + item.label
              + (labelPrefix ? ' (' + labelPrefix + ')' : ''));
          }
        });
      }
    });

    // require_one: at least one optional item must be complete
    if (requireOne && hasOptional && optionalCompleted === 0 && !errors.length) {
      errors.push('Please select one option from: ' + (labelPrefix || 'the section'));
    }

    return { props: props, errors: errors };
  }

  function collectMix(opts, slots, prefix, total, labelPrefix) {
    var props = {};
    var errors = [];
    var runningTotal = 0;
    for (var s = 0; s < slots; s++) {
      var qtyEl = container.querySelector('[data-slot-ref="' + prefix + '"][data-slot-idx="' + s + '"] .bc-slot__qty') ||
                  container.querySelector('.bc-slot[data-slot-prefix="' + prefix + '"][data-slot-idx="' + s + '"] .bc-slot__qty');
      // Fallback selector using slot index
      if (!qtyEl) {
        var allQty = container.querySelectorAll('[data-slot-ref="' + prefix + '"]');
        qtyEl = allQty[s] || null;
      }
      var qty = qtyEl ? Math.max(0, parseInt(qtyEl.value || '0', 10)) : 0;
      if (qty === 0) continue;
      runningTotal += qty;
      (opts || []).forEach(function (opt, oi) {
        var val = getChecked(prefix + 's' + s + 'o' + oi);
        var key = (labelPrefix ? labelPrefix + ' — ' : '') + 'Slot ' + (s + 1) + ' — ' + opt.name;
        if (val) {
          props[key] = val;
        } else {
          errors.push('Please select ' + opt.name + ' for slot ' + (s + 1)
            + (labelPrefix ? ' (' + labelPrefix + ')' : ''));
        }
      });
      var qtyKey = (labelPrefix ? labelPrefix + ' — ' : '') + 'Slot ' + (s + 1) + ' — Qty';
      props[qtyKey] = String(qty);
    }
    if (runningTotal !== total) {
      errors.push((labelPrefix ? labelPrefix + ': p' : 'P') + 'lease select exactly ' + total
        + ' item' + (total !== 1 ? 's' : '')
        + ' (currently ' + runningTotal + ')');
    }
    return { props: props, errors: errors };
  }

  function collectAll() {
    var allProps = {};
    var allErrors = [];
    var surchargeVariantIds = []; // variant IDs to add as extra cart line items

    function merge(result) {
      Object.assign(allProps, result.props);
      allErrors = allErrors.concat(result.errors);
    }

    if (config.type === 'fixed') {
      // Collect bundle-level options first
      (config.bundle_options || []).forEach(function (opt, oi) {
        if (opt.multi) {
          // Checkbox mode: collect all checked values + any surcharge variant IDs
          var checked = [];
          (opt.values || []).forEach(function (rawVal, vi) {
            var el = container.querySelector('#bcgo' + oi + 'v' + vi + ':checked');
            if (el) {
              checked.push(el.value);
              // If this value has a surcharge variant, queue it
              if (typeof rawVal === 'object' && rawVal !== null && rawVal.variant_id) {
                surchargeVariantIds.push(rawVal.variant_id);
              }
            }
          });
          if (checked.length) {
            allProps[opt.name] = checked.join(', ');
          } else {
            allErrors.push('Please select at least one ' + opt.name);
          }
        } else {
          // Radio mode: only one value
          var val = getChecked('bcgo' + oi);
          if (val) {
            allProps[opt.name] = val;
            // Check for surcharge variant on the matched value
            var matchedRaw = (opt.values || []).find(function (v) {
              return (typeof v === 'object' && v !== null ? v.label : v) === val;
            });
            if (matchedRaw && typeof matchedRaw === 'object' && matchedRaw.variant_id) {
              surchargeVariantIds.push(matchedRaw.variant_id);
            }
          } else {
            allErrors.push('Please select a ' + opt.name);
          }
        }
      });
      merge(collectFixed(config.items, 'bci', null));
    } else if (config.type === 'mix') {
      merge(collectMix(config.options, config.slots || 3, 'bcm', config.total || 0, null));
    } else if (config.type === 'sections') {
      (config.sections || []).forEach(function (sec, si) {
        if (sec.type === 'fixed') {
          merge(collectFixed(sec.items, 'bcs' + si, sec.label, sec.require_one));
        } else if (sec.type === 'mix') {
          merge(collectMix(sec.options, sec.slots || 3, 'bcs' + si + 'm', sec.total || 0, sec.label));
        }
      });
    }

    if (config.logo_upload && logoUrl) {
      allProps['_logo_url'] = logoUrl;  // hidden from checkout, visible to merchant in order admin
      allProps['Logo'] = '✓ Uploaded'; // visible label only — no URL shown to customer
    }

    return { props: allProps, errors: allErrors, surchargeVariantIds: surchargeVariantIds };
  }

  /* ─── Error banner ───────────────────────────────────────────── */
  var errorBanner = document.createElement('div');
  errorBanner.className = 'bc-error-banner';
  errorBanner.id = 'bc-error-banner';
  container.after(errorBanner);

  function showError(messages) {
    errorBanner.innerHTML = messages.map(function (m) { return '⚠ ' + esc(m); }).join('<br>');
    errorBanner.classList.add('visible');
    errorBanner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearError() {
    errorBanner.classList.remove('visible');
    errorBanner.innerHTML = '';
  }

  // Clear error whenever the user interacts with the configurator
  container.addEventListener('change', clearError);
  container.addEventListener('input', clearError);

  /* ─── Hook form submit ────────────────────────────────────────── */
  var form = document.getElementById('product-form');
  if (!form) return;

  // Run in capture phase so we execute before the existing bubble-phase listener
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    clearError();
    var result = collectAll();

    if (result.errors.length) {
      showError(result.errors);
      return;
    }

    var btn = document.getElementById('add-to-cart');
    var origText = btn ? btn.textContent : 'Add to basket';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    // Clean up any old hidden inputs from a previous attempt
    form.querySelectorAll('.bc-hidden-prop').forEach(function (el) { el.remove(); });

    // Inject line item properties as hidden inputs
    Object.keys(result.props).forEach(function (key) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + key + ']';
      inp.value = result.props[key];
      inp.className = 'bc-hidden-prop';
      form.appendChild(inp);
    });

    // Add the main bundle item first, then any print surcharge variants
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        // Add surcharge line items if any print options were selected
        var surcharges = result.surchargeVariantIds || [];
        if (!surcharges.length) {
          window.location.href = '/cart';
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: surcharges.map(function (vid) {
              return { id: vid, quantity: 1 };
            }),
          }),
        }).then(function (r2) {
          if (!r2.ok) throw new Error('Surcharge HTTP ' + r2.status);
          window.location.href = '/cart';
        });
      })
      .catch(function (err) {
        console.error('[bundle-configurator] Cart add failed:', err);
        if (btn) { btn.disabled = false; btn.textContent = origText; }
        // Clean up injected inputs so a retry works cleanly
        form.querySelectorAll('.bc-hidden-prop').forEach(function (el) { el.remove(); });
        showError(['There was a problem adding to your basket. Please try again.']);
      });
  }, true /* capture phase */);

})();
